import { Component, ChangeDetectorRef, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { DocumentRequirementRegistration } from "../../../models/document_requirement_registration";
import { DocumentRegistrationsControllerService } from "../../../services/crossed-tables/document-registrations-controller.service";
import { ModalService } from "../../utils/base_modal.component";
import { BaseError } from "../base-error";

@Component({
  selector: "app-crossed-tables",
  templateUrl: "document-registrations.component.html",
  styles: [".cursor-hand {cursor: pointer;}"],
  providers: [DocumentRegistrationsControllerService, ModalService, ToastrService],
})
export class DocumentRegistrationsComponent extends BaseError implements OnInit {

  public documentRequestRegistrations: DocumentRequirementRegistration[][] = [];
  public selectedDocumentRequirementRegistration: DocumentRequirementRegistration = new DocumentRequirementRegistration();

  public serviceId: string;
  public showModal = false;
  public tableSwitched: boolean = false;
  @ViewChild("smModal") public smModal;
  @Output() public modalClosedEvent = new EventEmitter();
  @ViewChild("trans_requirement_to_upload") public requirement_to_upload: ElementRef;
  @ViewChild("trans_requirement_to_show") public requirement_to_show: ElementRef;
  @ViewChild("trans_requirement_to_sign") public requirement_to_sign: ElementRef;
  @ViewChild("trans_requirement_to_print_upload") public requirement_to_print_upload: ElementRef;
  @ViewChild("trans_result_is_physical") public physical_result: ElementRef;
  @ViewChild("trans_result_is_digital") public dematerialized_result: ElementRef;

  constructor(private documentRegistrationsController: DocumentRegistrationsControllerService,
              private route: ActivatedRoute,
              toastr: ToastrService,
              private cdr: ChangeDetectorRef,
  ) {
    super(toastr);
  }

  public ngOnInit() {
    this.cdr.detectChanges();
    this.route.params.subscribe((params) => {
      this.serviceId = params.serviceId;
    });
    this.getDocumentRequestRegistrations();
  }

  public getDocumentRequestRegistrations() {
    this.documentRegistrationsController.getDocumentRequestRegistrationsList(this.serviceId).subscribe(
      (data) => {
        this.documentRequestRegistrations = data;
        if (this.tableSwitched) {
          this.tableSwitched = false;
          this.switchHeadings();
        }
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public switchHeadings() {
    this.tableSwitched = !this.tableSwitched;
    const switchedEntries = [];
    if (this.documentRequestRegistrations[0]) {
      for (let j = 0; j < this.documentRequestRegistrations[0].length; j++) {
        const newRow = [];
        for (let i = 0; i < this.documentRequestRegistrations.length; i++) {
          newRow.push(this.documentRequestRegistrations[i][j]);
        }
        switchedEntries.push(newRow);
      }
    }
    this.documentRequestRegistrations = switchedEntries;
  }

  public editDocument(documentRequirementRegistration: DocumentRequirementRegistration) {
    if (documentRequirementRegistration) {
      this.selectedDocumentRequirementRegistration = documentRequirementRegistration;
      this.showModal = true;
    }
  }

  public updateDocumentRequestRegistration() {
    this.documentRegistrationsController.saveRequestRegistrations(this.selectedDocumentRequirementRegistration).subscribe(
      (data) => {
        this.getDocumentRequestRegistrations();
        this.showModal = false;
      },
      (error) => this.showErrorMessage(error),
    );
  }

  public onCancel(): void {
    this.showModal = false;
  }

}
